import {
  GetMemberGradesRequest,
  Grade,
} from 'supporter';
import { MemberGradeState } from '@/types/memberGrade';
import { api } from '@/api';
import { ActionContext } from 'vuex';

export default {
  namespaced: true,
  state: {
    memberGrades: [],
  },
  actions: {
    getMemberGrades(
      { commit }: ActionContext<MemberGradeState, any>,
      params: GetMemberGradesRequest,
    ): Promise<any> {
      return api
        .getMemberGrades(params)
        .then((res): void => {
          commit('SET_MEMBER_GRADE', res!.data);
        });
    },
  },
  mutations: {
    SET_MEMBER_GRADE(state: MemberGradeState, grades: Grade[]): void {
      state.memberGrades = grades;
    },
  },
  getters: {
    memberGradeList(state: MemberGradeState): Grade[] {
      return state.memberGrades;
    },
    memberGradeUsedList(state: MemberGradeState): Grade[] {
      return state.memberGrades
        .filter(grade => grade.used)
        .sort((prev, next) => next.order - prev.order)
    }
  },
};
